<script>
  import { fade, slide, blur, fly } from "svelte/transition";
  export let refresh = "";
  $: console.log(refresh);
</script>

{#key refresh}
  <main
    class="min-h-[calc(100vh-4.5rem)]"
    in:fly={{ x: -300, duration: 1500 }}
  >
    <slot />
  </main>
{/key}
